exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".variant+.variant[data-v-3e95a8a0]:before{content:\"/ \"}", ""]);

// exports
